/**
 * On change restaurant, store id in session
 */
import { delay, split } from 'lodash';
import { displayCalendar } from './reservations'
window.$("#restaurants").on('change', function (e) {
    e.preventDefault();
    var restaurant_id = window.$(this).val();

    var ajaxUrl = window.$('#setRestaurantSessionRoute').val();
    var date = window.$('#visible_start').val();

    window.axios({
        method: "post",
        url: ajaxUrl,
        data: { "restaurantID": restaurant_id, "browser_url": window.location.pathname, "date": date }
    })
        .then(function (response) {
            // setTimeout(function () {
            const reloadUrl = response.data.redirectTo.split('/')
            if (reloadUrl["3"] == "timematrix") {
                reloadUrl["2"] = restaurant_id
                var selectedRestId = window.$('#selectedRestId').val(restaurant_id);
                window.location = reloadUrl.join("/");
            } else if (!reloadUrl["3"]) {
                // console.log(reloadUrl)
                var selectedRestId = window.$('#selectedRestId').val(restaurant_id);
                window.location = reloadUrl.join("/");
            }
            else {
                reloadUrl["4"] = restaurant_id
                // console.log(reloadUrl)
                var selectedRestId = window.$('#selectedRestId').val(restaurant_id);
                window.location = reloadUrl.join("/");
            }

            // }, 1000);
            // window.location = response.data.redirecTo;
        })
        .catch(function (error) {
            // console.log(error)
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Get restaurants to populate dropdown in header
 */
window.$(document).ready(function () {


    const restaurant_id = window.location.pathname.split('/')[2]
    $('.navbar-brand').attr('href', '/core/' + restaurant_id)
    $('#dashboard_side_bar').attr('href', '/core/' + restaurant_id)


    var selectedRestId = window.$('#selectedRestId').val(restaurant_id);


    // REMOVE SORTING CLASS FOR SEARCH FIELD
    setTimeout(function () {
        $('.editor').richText();
        $(".reservationsTable").find('tr:eq(1) >td').removeClass('sorting');
    }, 1000)


    var ajaxUrl = window.$('#getRestRoute').val();
    var selectedRestId = window.$('#selectedRestId').val();
    if (ajaxUrl) {
        window.axios({
            method: "get",
            url: ajaxUrl,
            data: {}
        })
            .then(function (response) {
                var restaurants = response.data.restaurants;
                for (var obj in restaurants) {
                    var selected = '';
                    if (restaurants[obj].id == selectedRestId) {
                        selected = "selected";
                    }
                    if(window.$("#top-rest-name").hasClass("top-rest-name")){
                        window.$("#top-rest-name").html(restaurants[obj].name);
                    }
                    var dropdown_option = "<option value='" + restaurants[obj].id + "'" + selected + ">" + restaurants[obj].name + "</option>";
                    window.$(dropdown_option).appendTo('#restaurants');

                }
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status == 400) {
                        window.$.each(error.response.data, function (key, value) {
                            window.$('#' + key + '-error').text(value[0]);
                        });
                    } else if (error.response.status == 403) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                    } else if (error.response.status == 401) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                        window.location = '/';
                    }

                }
            });
        return false;
    }
});

window.onload = function () {
    //for datatable sorting icon
    $('.editor').richText();

    var table = window.$('table.dataTable').DataTable();
    table.columns().iterator('column', function (ctx, idx) {
        window.$(table.column(idx).header()).append('<span class="sort-icon"/>');
    });

};

// Common method for delete confirmation
var deleteConfirmationAlert = function deleteConfirmationAlert(confirmationMessage) {
    var deferred = window.$.Deferred();
    var message = (typeof confirmationMessage !== 'undefined' && confirmationMessage !== '') ? confirmationMessage : "";

    /*open confirmation modal and fill with body*/
    if (message !== '') {
        window.$('#modal-body-content').text(message);
    }
    window.$(".delete_confirmation_modal#mi-modal").modal('show');

    var promise = confirmModal();
    promise.then(function (result) {
        deferred.resolve(true);
    }).catch(function (err) {
        deferred.reject(false);
    });
    return deferred.promise();

};

var confirmModal = function () {
    var deferred = window.$.Deferred();

    window.$(".delete_confirmation_modal #modal-btn-yes").on("click", function () {
        window.$(".delete_confirmation_modal#mi-modal").modal('hide');
        deferred.resolve(true);
    });

    window.$(".delete_confirmation_modal #modal-btn-no").on("click", function () {
        window.$(".delete_confirmation_modal#mi-modal").modal('hide');
        deferred.reject(false);
    });
    return deferred.promise();
};

export { deleteConfirmationAlert };


// Add search field below datatable columns
export function searchByTableColumns(tableObject, tablesCombinationIdentifier, excluded_columns) {
    window.$(tablesCombinationIdentifier + ' thead tr').clone(true).appendTo(tablesCombinationIdentifier + ' thead');
    window.$(tablesCombinationIdentifier + ' thead tr:eq(1) th').each(function (i) {
        $(this).replaceWith("<td class='" + this.className + "'>" + $(this).html() + "</td>");
    });
    window.$(tablesCombinationIdentifier + ' thead tr:eq(1) td').each(function (i) {
        i = i + 1;
        var title = window.$(this).text();
        if (excluded_columns.indexOf(i) == -1) {
            //console.log(this.className);
            // datepicket selection for search input reservation list
            if (this.className.indexOf('datepicker-selector') != -1) {
                window.$(this).html('<input type="text" autocomplete="off" class="datepicket-without-date-restriction" id="datatable_search_date" read-only placeholder="' + SEARCH + '" />');
            } else if (this.className.indexOf('reservation_status') != -1) {


                //var statusDropdown = '<select multiple="multiple" class="form-control multi-selection" data-live-search="true" data-allow-clear="true" id="reservation_status_filter">';
                var statusDropdown = '<select autocomplete="off" multiple="multiple" class="form-control" data-live-search="true" data-allow-clear="true" id="reservation_status_filter">';
                // statusDropdown += '<option></option>';
                window.$.each(RESERVATION_STATUS, function (key, val) {
                    statusDropdown += '<option value=' + key + '>' + val + ' </option>';
                });
                statusDropdown += '</select > ';
                window.$(this).html(statusDropdown);
                //select2Dropdown();
                $("#reservation_status_filter").multiselect();

            } else if (this.className.indexOf('reservation_phase') != -1) {

                var thisFilter = this;
                window.axios({
                    method: "post",
                    url: window.$(".tables_management").attr('phase-url'),
                    data: {
                        'restaurant_id': window.$('#restaurants').val()
                    }
                }).then(function (response) {
                    
                    var phaseDropdown = '<select autocomplete="off" multiple="multiple" class="form-control" data-live-search="true" data-allow-clear="true" id="reservation_phase_filter">';
                    // areaDropdown += '<option></option>';
                    window.$.each(response.data, function (key, val) {
                        phaseDropdown += '<option value=' + val.id + '>' + val.name + ' </option>';
                    });
                    phaseDropdown += '</select >';
                    window.$(thisFilter).html(phaseDropdown);
                    $("#reservation_phase_filter").multiselect();
                    //select2Dropdown();
                    
                })

            } else if (this.className.indexOf('area') != -1) {


                var thisFilter = this;
                window.axios({
                    method: "post",
                    url: window.$(".tables_management").attr('data-url'),
                    data: {
                        'restaurant_id': window.$('#restaurants').val()
                    }
                })
                    .then(function (response) {
                        var areaDropdown = '<select autocomplete="off" multiple="multiple" class="form-control" data-live-search="true" data-allow-clear="true" id="area_filter">';
                        // areaDropdown += '<option></option>';
                        window.$.each(response.data, function (key, val) {
                            areaDropdown += '<option value=' + val.id + '>' + val.name + ' </option>';
                        });
                        areaDropdown += '</select >';
                        window.$(thisFilter).html(areaDropdown);
                        $("#area_filter").multiselect();
                        //select2Dropdown();
                    })


            } else if (this.className.indexOf('report_type') != -1) {
                var reportTypeDropdown = '<select autocomplete="off" class="form-control single-selection" data-live-search="true" data-allow-clear="true" id="report_type_filter">';
                reportTypeDropdown += '<option></option>';
                window.$.each(REPORT_TYPE, function (key, val) {
                    reportTypeDropdown += '<option value=' + key + '>' + val + ' </option>';
                });
                reportTypeDropdown += '</select > ';
                window.$(this).html(reportTypeDropdown);
                //window.$(this).html('<input type="text" class="reservation_status" placeholder="' + SEARCH + '" />');
            } else if (this.className.indexOf('time_slot') != -1) {
                var timeSlot = '<input type="text" autocomplete="off" name="start_time" placeholder="HH:mm" required class="time start_time clock_timePickerDesktop" pattern="^(\d{2}):(\d{2})$">';
                window.$(this).html(timeSlot);
                commonClockTimepickerForDesktop();
                //window.$(this).html('<input type="text" class="reservation_status" placeholder="' + SEARCH + '" />');
            } else if (this.className.indexOf('enquiry_status') != -1) {
                var statusDropdown = '<select autocomplete="off" class="form-control single-selection" data-live-search="true" data-allow-clear="true" id="enquiry_status_filter">';
                statusDropdown += '<option></option>';
                window.$.each(ENQUIRY_STATUS, function (key, val) {
                    statusDropdown += '<option value=' + key + '>' + val + ' </option>';
                });
                statusDropdown += '</select > ';
                window.$(this).html(statusDropdown);
                //window.$(this).html('<input type="text" class="reservation_status" placeholder="' + SEARCH + '" />');
            } else {
                window.$(this).html('<input type="text" autocomplete="off" readonly onclick="this.removeAttribute(\'readonly\');" data-lpignore="true" placeholder="' + SEARCH + '" class="search_filter" />');
            }
            
            window.$('input', this).on('keyup change', debounce(function() {
                if (tableObject.column(i).search() !== this.value) {
                    tableObject.column(i).search(this.value).draw();
                }
            }, 1000)
            );
            /*
            
            window.$('input', this).on('keyup change', function (e) {
                if (tableObject.column(i).search() !== this.value) {
                    tableObject.column(i).search(this.value).draw();
                }
            });
            */

        } else {
            $(this).html('');
        }
    });
};

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var myEfficientFn = debounce(function() {
	if (tableObject.column(i).search() !== this.value) {
        tableObject.column(i).search(this.value).draw();
    }
}, 5000);

// Initialize tooltip
window.$(document).ajaxComplete(function () {
    window.$('[data-toggle="tooltip"]').tooltip();
});

// Clock timepicker script
window.onload = function () {
    commonClockTimepicker();
    commonClockTimepickerForDesktop();
    setTimeout(function () {
        commonDatepicker();
    }, 2500);
    select2Dropdown();
    reservationDatepicker();
};
var commonClockTimepickerForDesktop = function commonClockTimepickerForDesktop() {
    window.$('.clock_timePickerDesktop').clockTimePicker({
        durationNegative: false,
        precision: 1,
        onlyShowClockOnMobile: true
    });
}
let timePickerMask = () => {
    Inputmask("datetime", {
        inputFormat: "HH:MM",
        max: 24
    }).mask(".timepickerformat");
}
var commonClockTimepicker = function commonClockTimepicker() {

    window.$('.clock_timePicker').clockTimePicker({
        durationNegative: false,
        precision: 1,
        onlyShowClockOnMobile: true
    });
}
let currentTime = (date = new Date())=>{
  const minutes = 15;
  const ms = 1000 * 60 * minutes;
  const currentDateTime = new Date(Math.ceil(date.getTime() / ms) * ms);
   let hours   = ('0' + currentDateTime.getHours()).slice(-2);
   let min = ('0' + currentDateTime.getMinutes()).slice(-2);
  return hours+':'+min;
};

var select2Dropdown = function (whichTime='') {
    // Single selection setting
    window.$('.single-selection').select2({
        placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
    });
    if(whichTime == 'currentTime'){
        //console.log(currentTime())
        window.$("#start_time").val(currentTime()).trigger('change');
    }
    // Multi selection setting
    window.$('.multi-selection').select2({
        placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
        closeOnSelect: false,
        debugger: true,
        templateResult: formatOption

        // containerCssClass:'multiSelectOption',
        // dropdownCssClass: "multiSelectOption",
    }).on('change', function (e) {
        var data = $("option:selected", this).text();
        if (data) {
            $(this).next('span').find('.select2-search--inline').hide();
        } else {
            $(this).next('span').find('.select2-search--inline').show();
        }
    });
}
function formatOption(option) {
    var $option = $(
        '<div class="table-heading">' + option.text + '</div><small class="text-secondary">' + option.title + '</small>'
    );
    return $option;
};

var commonDatepicker = function () {
    window.$(".datepicker").datetimepicker({
        timepicker: false,
        format: DATE_FORMAT,
        dayOfWeekStart: 1,
        yearStart: 1900,
        yearEnd: new Date().getFullYear(),
        monthStart: 0,
        /*monthEnd: new Date().getMonth(),*/
        maxDate: 0,
        scrollYear: false,
        scrollMonth: false,
        scrollInput: false,
        onClose: function (dateText, inst) {
            // var date = moment(dateText).format(DATE_FORMAT_GUEST);
            // window.$(inst).val(date);
        },
        onChangeYear: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        },
        onChangeMonth: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        }
    });

    window.$(".datepicket-without-date-restriction").datetimepicker({
        dayOfWeekStart: 1,
        timepicker: false,
        format: DATE_FORMAT,
        scrollYear: false,
        scrollMonth: false,
        scrollInput: false,
        onClose: function (dateText, inst) {
            // var date = moment(dateText).format(DATE_FORMAT_GUEST);
            // window.$(inst).val(date);
        },
        onChangeYear: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        },
        onChangeMonth: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        }
    });



}
var reservationDatepicker = function () {
    window.$(".reservation-datepicker").datetimepicker({
        dayOfWeekStart: 1,
        timepicker: false,
        format: DATE_FORMAT,
        yearStart: new Date().getFullYear(),
        /*monthStart: new Date().getMonth(),*/
        /*minDate: new Date(),*/ 
        scrollYear: false,
        scrollMonth: false,
        scrollInput: false,
        onClose: function (dateText, inst) {
            // var date = moment(dateText).format(DATE_FORMAT_GUEST);
            // window.$(inst).val(date);
        },
        onChangeYear: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        },
        onChangeMonth: function (dateText, inst) {
            var date = moment(dateText).format(DATE_FORMAT_GUEST);
            window.$(inst).val(date);
        },
        onChangeDateTime: function (dp, $input) {
            window.$("#reservation_date").val($input.val());
            displayCalendar(dp);
        }
    }).focus(function () {
        window.$(".xdsoft_prev").hide();
        window.$(".xdsoft_next").hide();
    });;

}
let copyWidgetCode = function () {
    const copyText = document.getElementById("widgetcodeSnippetGlobal").textContent;
    const textArea = document.createElement('textarea');
    textArea.setAttribute("id", 'globalwidgetcodesnippetarea');
    textArea.textContent = copyText;
    document.body.append(textArea);
    textArea.select();
    document.execCommand("copy");
    document.getElementById("globalwidgetcodesnippetarea").remove();
    window.toastr.success('Copied');
};
let _getWidgetConfigData = async function (restaurant_id) {
    let widgetAPI_URL = window.$("#app").attr('widgeturl') + "/index.js";
    window.axios({
        method: "post",
        url: window.$("#app").attr('widgetConfigURL'),
        data: { restaurant_id: restaurant_id }
    }).then(function (response) {
        let snippetData = {};
        let finalconfig;
        let buttonConfig, widgetConfig = {};
        let responsedata = response.data.data;
        if (responsedata != '') {
            buttonConfig = responsedata.raw_button_config;
            widgetConfig = responsedata.raw_widget_config;
            finalconfig = { ...buttonConfig, ...widgetConfig };
        }
        let globalcodeSnippet = "&lt;div class='muru-widget-builder'&gt; &lt;script type='module' id='widgetForm' name='widgetScript' data-restaurantid='" + restaurant_id + "' data-src='widget' data-widgetconfig='" + JSON.stringify(finalconfig) + "' src='" + widgetAPI_URL + "'&gt;&lt;/script&gt;&lt;/div&gt;";
        window.$("#widgetcodeSnippetGlobal").html(globalcodeSnippet);
    }).catch(function (error) {

    });
}

window.$("#goToForgotPassword").on('click', function () {
    $("#login_form").hide();
    $("#forgot_form").show();
});
var forgotemailfield = document.getElementById("forgot_email");
if (forgotemailfield) {
    forgotemailfield.addEventListener("keyup", function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            document.getElementById("forgot_nxt_btn").click();
        }
    });
}
window.$("#forgot_login_btn").on('click', function () {
    $("#forgotpasswordform")[0].reset()
    $("#forgot_form").hide();
    $("#login_form").show();
});
window.$("#forgot_nxt_btn").on('click', function () {
    let forgotemail = $("#forgot_email").val();
    let forgotUrl = window.$("#forgotpasswordform").attr('url');
    window.$("#forgot-email-error").text("");
    window.$("#forgot_email").removeClass('forgot_invalid');
    window.$(".response_note").css('display', 'none').removeClass('response_success_note').removeClass('response_fail_note').text('');
    if (!forgotemail) {
        window.$("#forgot_email").addClass('forgot_invalid');
        window.$("#forgot-email-error").text("Enter your email address.")
        return false;
    }
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(forgotemail)) {
        window.axios({
            method: "post",
            url: forgotUrl,
            data: { email: forgotemail, _token: window.$('meta[name="csrf-token"]').attr('content') }
        })
            .then(function (response) {
                $(".response_note").css('display', 'block').addClass('response_success_note').text(response.data.message);
                // window.toastr.success(response.data.message, response.statusText);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    $(".response_note").css('display', 'block').addClass('response_fail_note').text(error.response.data.message);
                } else {
                    for (const errorkey in error.response.data) {
                        if (errorkey == 'email') {
                            window.$("#forgot_email").addClass('forgot_invalid');
                            window.$("#forgot-email-error").text(error.response.data[errorkey][0])
                        }
                    }
                    return false;
                }
            })
    } else {
        $("#forgot-email-error").text("Invalid email address.")
        return false;
    }
});
window.$("#global_widget_copy").on('click', function () {
    copyWidgetCode();
});
window.$(document).on('click', ".copyWidgetCode", function () {
    let resId = $(this).attr('resid');
    _getWidgetConfigData(resId).then(function (value) {
        setTimeout(function () {
            copyWidgetCode();
        }, 500)

    });
})
setTimeout(function () {
    let _restaurant_id = window.$('#restaurants').val();
    //_getWidgetConfigData(_restaurant_id);
}, 500);

window.addEventListener('DOMContentLoaded', (event) => {
    let falseUrl = window.location.search.split('?')
    // console.log(falseUrl)
    if (falseUrl.length > 0) {
        if(falseUrl&&falseUrl[1]){
            if (falseUrl[1].includes("is_valid")) {
                window.toastr.error("Invalid restaurant", "Error");
                // url.split("?");
                window.history.pushState({}, document.title, window.location.pathname);
            }
        }
    }

    setTimeout(() => {
        var input = document.querySelector("#phone_code");
        if (input) {
            var phone_code = window.intlTelInput(input, {
                separateDialCode: true,
                preferredCountries: ["fi", "se"],
            });
        }

        window.$(".datepicket-without-date-restriction").datetimepicker({
            dayOfWeekStart: 1,
            timepicker: false,
            format: DATE_FORMAT,
            scrollYear: false,
            scrollMonth: false,
            scrollInput: false,
            onClose: function (dateText, inst) {
                // var date = moment(dateText).format(DATE_FORMAT_GUEST);
                // window.$(inst).val(date);
            },
            onChangeYear: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            },
            onChangeMonth: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            }
        });
        window.$("#datatable_search_date").datetimepicker({
            timepicker: false,
            format: DATE_FORMAT,
            scrollYear: false,
            scrollMonth: false,
            scrollInput: false,
            dayOfWeekStart: 1,
            onClose: function (dateText, inst) {
                // var date = moment(dateText).format(DATE_FORMAT_GUEST);
                // window.$(inst).val(date);
            },
            onChangeYear: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            },
            onChangeMonth: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            }
        });
    }, 1200);

    // COMMON RICHTEXT EDITOR SCRIPT
    var richTextEditor = document.getElementsByClassName("richTextEditor");
    for (var r = 0; r < richTextEditor.length; r++) {
        if (richTextEditor[r].id) {
            $("#" + richTextEditor[r].id).richText();
        }
    }
});
export { commonClockTimepicker, commonDatepicker, select2Dropdown, reservationDatepicker, timePickerMask };
